import { isPlatformBrowser } from '@angular/common'
import { Component, inject, OnInit, PLATFORM_ID, signal, ChangeDetectionStrategy } from '@angular/core'
import { ServiceNotification, ServiceNotificationsService } from '@shared/services/service-notifications.service'
import { ErrorMessageService } from '@shared/services/error-message.service'
import { HttpErrorResponse } from '@angular/common/http'
import { LoadingService } from '@shared/services/loading.service'
import { LoadingContexts } from '@shared/services/loading.interceptor'
import { AuthService } from '@shared/services/auth.service'

@Component({
  selector: 'app-service-notifications',
  imports: [],
  templateUrl: './service-notifications.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './service-notifications.component.scss',
})
export class ServiceNotificationsComponent implements OnInit {
  protected readonly LoadingContexts = LoadingContexts

  private errorMessageService = inject(ErrorMessageService)
  private serviceNotificationsService = inject(ServiceNotificationsService)
  private authService = inject(AuthService)
  private platformId = inject(PLATFORM_ID)
  loadingService = inject(LoadingService)

  notifications = signal<ServiceNotification[]>([])

  async ngOnInit() {
    if (!isPlatformBrowser(this.platformId) || !this.authService.customer()) {
      return
    }

    try {
      const notifications = await this.serviceNotificationsService.items()
      this.notifications.set(notifications)
    } catch (error) {
      this.errorMessageService.handleError(error as HttpErrorResponse)
    }
  }
}
